/* Kingdom Come — global.js
   Vanilla JS: mobile nav, cart drawer, AJAX add-to-cart, product gallery/variant swatches. */

document.addEventListener('DOMContentLoaded', function () {
  /* ---------- Mobile nav ---------- */
  var burger = document.querySelector('[data-mobile-nav-open]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileNavClose = document.querySelector('[data-mobile-nav-close]');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () { mobileNav.classList.add('is-open'); });
  }
  if (mobileNavClose && mobileNav) {
    mobileNavClose.addEventListener('click', function () { mobileNav.classList.remove('is-open'); });
  }

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');
  var cartOpeners = document.querySelectorAll('[data-cart-open]');
  var cartClosers = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
  }
  cartOpeners.forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
  cartClosers.forEach(function (el) { el.addEventListener('click', closeCart); });
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function renderCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function refreshCartDrawer() {
    fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var freshDrawer = doc.querySelector('[data-cart-drawer]');
        if (freshDrawer && cartDrawer) {
          cartDrawer.innerHTML = freshDrawer.innerHTML;
          bindCartDrawerEvents();
        }
      });
  }

  function bindCartDrawerEvents() {
    document.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', closeCart);
    });
    document.querySelectorAll('[data-qty-change]').forEach(function (el) {
      el.addEventListener('click', function () {
        var key = el.getAttribute('data-key');
        var delta = parseInt(el.getAttribute('data-qty-change'), 10);
        var input = document.querySelector('[data-qty-input="' + key + '"]');
        var newQty = Math.max(0, parseInt(input.value, 10) + delta);
        updateLineItem(key, newQty);
      });
    });
  }
  bindCartDrawerEvents();

  function updateLineItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartCount(cart.item_count);
        refreshCartDrawer();
      });
  }

  /* ---------- AJAX add to cart ---------- */
  document.querySelectorAll('#AddToCartForm').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.originalText = submitBtn.textContent; submitBtn.textContent = 'Adding...'; }

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          renderCartCount(cart.item_count);
          refreshCartDrawer();
          openCart();
        })
        .catch(function () {
          window.location.href = '/cart';
        })
        .finally(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.originalText; }
        });
    });
  });

  /* ---------- Product gallery thumbs ---------- */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var gallery = thumb.closest('[data-gallery]');
      var mainImg = gallery.querySelector('[data-gallery-main]');
      mainImg.src = thumb.getAttribute('data-full');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---------- Cart line quantity inputs on /cart page ---------- */
  document.querySelectorAll('[data-cart-page-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      updateLineItem(input.getAttribute('data-key'), parseInt(input.value, 10) || 0);
      setTimeout(function () { window.location.reload(); }, 400);
    });
  });
});
